"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var SvgEmbeddedDatasource = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", id: "EmbeddedDatasource_svg__Layer_1", x: 0, y: 0, xmlSpace: "preserve", width: 16, height: 16, role: "img" }, props),
    React.createElement("style", null, ".EmbeddedDatasource_svg__st0{fill:#666}"),
    React.createElement("path", { className: "EmbeddedDatasource_svg__st0", d: "M5.5 0C2.5 0 0 1.3 0 3v9c0 1.4 1.7 2.5 4 2.9v-1c-1.8-.3-3-1-3-1.9V4.7C2 5.5 3.6 6 5.5 6S9 5.5 10 4.7V8h1V3c0-1.7-2.5-3-5.5-3zm0 5C3 5 1 4.1 1 3s2-2 4.5-2 4.5.9 4.5 2-2 2-4.5 2z" }),
    React.createElement("path", { className: "EmbeddedDatasource_svg__st0", d: "M6 15c-.1 0-.3 0-.4-.1l-2.5-2.5c-.2-.2-.2-.5 0-.7l2.5-2.5c.2-.2.6-.2.8 0s.2.5 0 .7L4.2 12l2.1 2.1c.2.2.2.5 0 .7 0 .2-.2.2-.3.2zM12 15c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l2.1-2.1-2.1-2.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0l2.5 2.5c.2.2.2.5 0 .7L12.3 15H12zM7.5 15c-.1 0-.2 0-.3-.1-.2-.1-.3-.4-.2-.7l3.1-5c.1-.2.5-.3.7-.2.2.1.3.5.2.7l-3.1 5c-.1.2-.3.3-.4.3z" }))); };
var Memo = (0, react_1.memo)(SvgEmbeddedDatasource);
exports.default = Memo;
//# sourceMappingURL=EmbeddedDatasource.js.map